import styled from 'styled-components';

import {
  MethodContainer as BaseMethodContainer,
  MethodTypeWrapper as BaseMethodTypeWrapper,
  IMethodContainer,
} from './styled.base';

export * from './styled.base';

export const MethodContainer = styled(BaseMethodContainer)<IMethodContainer>`
  padding: 0;
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};

  svg {
    height: 0.75rem;
    fill: ${Styles.color.black};
  }
`;

export const MethodTypeWrapper = styled(BaseMethodTypeWrapper)`
  padding: 16px 24px 16px 16px;
`;
